import { render, staticRenderFns } from "./DispatchToAbattoirBatch.vue?vue&type=template&id=fee4f9f2&scoped=true"
import script from "./DispatchToAbattoirBatch.vue?vue&type=script&lang=ts"
export * from "./DispatchToAbattoirBatch.vue?vue&type=script&lang=ts"
import style0 from "./DispatchToAbattoirBatch.vue?vue&type=style&index=0&id=fee4f9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee4f9f2",
  null
  
)

export default component.exports